import { render, staticRenderFns } from "./ConsultarCartasParaAssinatura.vue?vue&type=template&id=09a53037&"
import script from "./ConsultarCartasParaAssinatura.vue?vue&type=script&lang=js&"
export * from "./ConsultarCartasParaAssinatura.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports